import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const OrderConfirmErrorRedirect: React.FC = () => {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    toast.error("Something went wrong, please try again");
    navigate("/order/place");
  }, [navigate]);

  return null;
};
